import { createElement } from "react";
import * as Icons from "@mui/icons-material/";
type IconType = typeof import("@mui/icons-material/index");

const DynamicIcon = ({ iconName }: { iconName: string }) => {
  if (!Icons[iconName as keyof IconType]) {
    return null;
  }
  return createElement(Icons[iconName as keyof IconType]);
};

export default DynamicIcon;